import { motion } from "framer-motion";
import { useEffect, useMemo, useState } from "react";

import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  formatTime,
  getSevenDays,
  getThirtyDays,
  getThreeDays,
  getToday,
} from "../../utils/getDay";
import DateSelect from "../../components/TimePicker/DateSelect";
import DetailWrapper from "../../components/detailWrapper";
import ButtonTab from "../../components/TabComponent/ButtonTab";
import TotalBet from "./components/totalBet";
import GameHistory from "./components/gameHistory";

const BetRecord = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`betRecord.${key}`);
  const dispatch = useDispatch();

  const TAB = [
    {
      label: i18n("Total Win"),
      value: "Total Win",
    },
    {
      label: i18n("Game History"),
      value: "Game History",
    },
  ];

  const [tab, setTab] = useState(TAB[0].value);
  const [datePicker, setDatePicker] = useState({
    str_date: getToday(),
    end_date: getToday(),
  }); //這個是時間選擇器的state 对象的初始值是通过调用 getToday() 函数获取的，这个函数用于获取当前日期

  const customDateList = useMemo(() => {
    return tab === "Game History"
      ? [
          {
            text: "Last 24 hours",
            value: 1,
            startDate: getToday(),
            endDate: getToday(),
          },
          {
            text: "Last 3 days",
            value: 3,
            startDate: getThreeDays(),
            endDate: getToday(),
          },
          {
            text: "Last 7 days",
            value: 7,
            startDate: getSevenDays(),
            endDate: getToday(),
          },
          {
            text: "Last 30 days",
            value: 30,
            startDate: getThirtyDays(),
            endDate: getToday(),
          },
        ]
      : [];
  }, [tab]);

  return (
    <DetailWrapper>
      <CloseDetailPage title={i18n("title")} />
      <section className="py-common-padding-y">
        <section className="flex items-center mb-[10px]">
          <ButtonTab TABS={TAB} setTab={setTab} tab={tab} />
        </section>

        <section>
          <DateSelect setDatePicker={setDatePicker} />
        </section>
        <section className="flex flex-col gap-[10px]">
          {tab === "Total Win" ? (
            <TotalBet datePicker={datePicker} />
          ) : (
            <GameHistory datePicker={datePicker} />
          )}
        </section>
      </section>
    </DetailWrapper>
  );
};

export default BetRecord;
